import styled from "styled-components"

const Input = styled.input`
  padding: 4px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1em;
  margin-bottom: 8px;
  box-sizing: border-box;
  width: 100%;
  height: 40px;
`

export default Input
